// store/actions/SymptomActions.js
import {
  CONFIRMED_CREATE_SYMPTOM_ACTION,
  CONFIRMED_DELETE_SYMPTOM_ACTION,
  CONFIRMED_EDIT_SYMPTOM_ACTION,
  CONFIRMED_GET_SYMPTOMS,
} from "./SymptomTypes";

import {
  createSymptom,
  deleteSymptom,
  getSymptoms,
  updateSymptom,
  formatSymptoms,
} from "../../services/SymptomsService";

import swal from "sweetalert";
import { handleError, handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";

// Utility: get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

// export function getSymptomsAction(pagination = true, pageid = 0,search_by = "", search_keyword = "",sort_by = "", sort_order = "") {
//   return async (dispatch, getState) => {
//     try {
//       const token = getAuthToken(getState);
//       const response = await getSymptoms(pagination, pageid,search_by,search_keyword, sort_by, sort_order,token);

//       if (response?.status === 200 && response.data?.status === "success") {
//         const symptoms = formatSymptoms(response.data.data);
//         dispatch({ type: CONFIRMED_GET_SYMPTOMS, payload: symptoms });
//       } else {
//         handleError("Failed to get symptoms: Server error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get symptoms",);
//     }
//   };
// }
export function getSymptomsAction(
  pagination = true,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_by = "symptom_name",
  sort_order = "asc"
) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const response = await getSymptoms(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_by,
        sort_order,
        token
      );
      
      if (response?.status === 200 && response.data?.status === "success") {
        const symptoms = formatSymptoms(response.data.data);
        const num_rows = response.data.num_rows || 0;
        
        dispatch({
          type: CONFIRMED_GET_SYMPTOMS,
          payload: { symptoms, num_rows },
        });
      } else {
        handleError("Failed to get symptoms: Server error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get symptoms");
    }
  };
}

export function deleteSymptomAction(symptom) {
  return async (dispatch) => {
    try {
      const response = await deleteSymptom(symptom);
      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_DELETE_SYMPTOM_ACTION,
          payload: { symptom_id: symptom.symptom_id },
        });
        handleSuccess("Symptom deleted successfully!");
      } else {
        showErrorAlert(
          
          response?.data?.message || "Failed to delete symptom"
        );
      }
    } catch (error) {
      console.error(error);
      showErrorAlert(
        
        error.response?.data?.message || "Failed to delete symptom"
      );
    }
  };
}

export function createSymptomAction(symptomData, navigate) {
  return async (dispatch) => {
    try {
      const response = await createSymptom(symptomData);

      if (response?.data?.status === "success") {
        const newSymptom = {
          symptom_id: response.data.data.symptom_id,
          symptom_name: response.data.data.symptom_name,
          symptom_description: response.data.data.symptom_description,
          symptom_status: response.data.data.symptom_status,
        };

        dispatch({
          type: CONFIRMED_CREATE_SYMPTOM_ACTION,
          payload: newSymptom,
        });

        handleSuccess("Symptom created successfully!");
        if (navigate) navigate("/symptoms");
      } else {
        showErrorAlert(
          
          response.data?.message || "Failed to create symptom"
        );
      }
    } catch (error) {
      console.error("Create Symptom Error:", error);
      showErrorAlert(
        
        error.response?.data?.message || "Failed to create symptom"
      );
    }
  };
}

export function updateSymptomAction(symptomData, symptomId, navigate) {
  return async (dispatch) => {
    try {
      const response = await updateSymptom(symptomData, symptomId);

      if (response?.data?.status === "success") {
        const updatedSymptom = response.data.data;

        dispatch({
          type: CONFIRMED_EDIT_SYMPTOM_ACTION,
          payload: updatedSymptom,
        });

        handleSuccess("Symptom updated successfully!");
        if (navigate) navigate("/symptoms");
      } else {
        showErrorAlert(
          
          response.data?.message || "Failed to update symptom"
        );
      }
    } catch (error) {
      console.error("Update Symptom Error:", error);
      showErrorAlert(
        
        error.response?.data?.message || "Failed to update symptom"
      );
    }
  };
}
